import React from 'react';
// import {FormGroup, Label, Input, Button} from 'reactstrap';
// import mesereando from '../imgFED/mesereando.png';
import BoxGet from "../components/BoxGet";

const GetIn = () => {
    return (
      <section className={"burguer"}>
      <div className={"overlay"}>
          <BoxGet />
      </div>          
        </section>
    );
}

export default GetIn;
